import React, { useEffect, useState } from 'react';
import SelectClient from './Components/SelectClient';
import SelectBenefit from './Components/SelectBenefit';
import SelectBenefitGroup from './Components/SelectBenefitGroup';
import ClientPricingFlow from './Components/ClientPricingFlow';
import SelectAirport from './Components/SelectAirport';
import SelectZone from './Components/SelectZone';
import SelectVendor from './Components/SelectVendor';
import AssignZonesToVendors from './Components/AssignZonesToVendors';
import AddVendorPricing from './Components/AddVendorPricing';
import SelectProject from './Components/SelectProject';
import AssignZonesToClient from './Components/AssignZonesToClient';
import AddClientPricing from './Components/AddClientPricing';
import ConfigurationChecklist from './Components/ConfigurationCheckList';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../../../../Common';
import {
  GET_LIVE_CONFIG,
  GET_LIVE_CONFIG_EMPTY,
  GET_ONBOARDING_CONFIGURATION,
  GET_ONBOARDING_CONFIGURATION_EMPTY,
  SAVE_DRAFT_CONFIGURATION_EMPTY,
  UPDATE_DRAFT_CONFIGURATION_EMPTY,
} from '../../../../../store/actions';
import UploadVendorPricing from './Components/UploadVendorPricing';
import UploadClientPricing from './Components/UploadClientPricing';
import queryString from 'query-string';

const getInitialValues = () => ({
  client: null,
  project: null,
  benefit: null,
  benefitGroup: null,
  clientPricing: {
    airports: [],
    pricingDetails: [],
  },
  vendorPricing: {
    airports: [],
    vendors: [],
    pricingDetails: [],
  },
  version: null,
});

const ProgramOnboarding = () => {
  const dispatch = useDispatch();

  const [state, setState] = useState(getInitialValues());
  const [formCount, setFormCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isDraftConfiguration, setIsDraftConfiguration] = useState(false);
  const [configuration, setConfiguration] = useState(null);
  const [fetchLiveConfigData, setFetchLiveConfigData] = useState(null);

  useEffect(() => {
    return () => {
      setState(getInitialValues());
    };
  }, []);

  const { id = '' } = queryString.parse(location.search);

  const {
    getClientLoading,
    getProjectLoading,
    getBenefitLoading,
    getClientDetailsLoading,
    saveDraftConfiguration,
    saveDraftConfigurationLoading,
    updateDraftConfiguration,
    updateDraftConfigurationLoading,
    downloadPriceTypeLoading,
    getOnboardingConfiguration,
    getOnboardingConfigurationLoading,
    getLiveConfig,
    getLiveConfigLoading,
  } = useSelector((state: any) => ({
    getClientLoading: state.GetClientV2.loading,
    getProjectLoading: state.GetProjectV2.loading,

    getBenefitLoading: state.GetBenefitAndBenefitGroup?.loading,
    getClientDetailsLoading: state.GetClientDetailsV2?.loading,

    saveDraftConfiguration: state.SaveDraftConfiguration.data,
    saveDraftConfigurationLoading: state.SaveDraftConfiguration.loading,

    updateDraftConfiguration: state.UpdateDraftConfiguration.data,
    updateDraftConfigurationLoading: state.UpdateDraftConfiguration.loading,

    downloadPriceType: state.DownloadPriceType.data,
    downloadPriceTypeLoading: state.DownloadPriceType.loading,

    getOnboardingConfiguration: state.GetOnboardingConfiguration.data,
    getOnboardingConfigurationLoading: state.GetOnboardingConfiguration.loading,

    getLiveConfig: state.GetLiveConfig.data,
    getLiveConfigLoading: state.GetLiveConfig.loading,
  }));

  useEffect(() => {
    if (id) {
      dispatch({
        type: GET_ONBOARDING_CONFIGURATION,
        payload: {
          id: id,
        },
      });
    }
  }, [id]);

  useEffect(() => {
    if (getOnboardingConfiguration !== null) {
      setState({
        client: getOnboardingConfiguration?.results?.configuration_data?.client,
        project: getOnboardingConfiguration?.results?.configuration_data?.project,
        benefit: getOnboardingConfiguration?.results?.configuration_data?.benefit,
        benefitGroup: getOnboardingConfiguration?.results?.configuration_data?.benefitGroup,
        clientPricing: {
          airports: getOnboardingConfiguration?.results?.configuration_data?.clientPricing?.airports ?? [],
          pricingDetails: getOnboardingConfiguration?.results?.configuration_data?.clientPricing?.pricingDetails ?? [],
        },
        vendorPricing: {
          airports: getOnboardingConfiguration?.results?.configuration_data?.vendorPricing?.airports ?? [],
          vendors: getOnboardingConfiguration?.results?.configuration_data?.vendorPricing?.vendors ?? [],
          pricingDetails: getOnboardingConfiguration?.results?.configuration_data?.vendorPricing?.pricingDetails ?? [],
        },
        version: getOnboardingConfiguration?.results?.version,
      });
      setFormCount(
        getOnboardingConfiguration?.results?.configuration_data?.page == 0
          ? 15
          : getOnboardingConfiguration?.results?.configuration_data?.page ?? '1',
      );
      setConfiguration(getOnboardingConfiguration?.results);
      setIsDraftConfiguration(true);
      dispatch({
        type: GET_ONBOARDING_CONFIGURATION_EMPTY,
      });
    }
  }, [getOnboardingConfiguration]);

  useEffect(() => {
    if (saveDraftConfiguration !== null) {
      setIsDraftConfiguration(true);
      setFormCount((prev: number) => prev + 1);
      setConfiguration(saveDraftConfiguration?.results);
      dispatch({
        type: SAVE_DRAFT_CONFIGURATION_EMPTY,
      });
    }
  }, [saveDraftConfiguration]);

  useEffect(() => {
    if (updateDraftConfiguration !== null) {
      setFormCount((prev: number) => prev + 1);
      dispatch({
        type: UPDATE_DRAFT_CONFIGURATION_EMPTY,
      });
    }
  }, [updateDraftConfiguration]);

  useEffect(() => {
    if (
      getClientLoading ||
      getProjectLoading ||
      getBenefitLoading ||
      getClientDetailsLoading ||
      saveDraftConfigurationLoading ||
      updateDraftConfigurationLoading ||
      downloadPriceTypeLoading ||
      getOnboardingConfigurationLoading ||
      getLiveConfigLoading
    ) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [
    getClientLoading,
    getProjectLoading,
    getBenefitLoading,
    getClientDetailsLoading,
    saveDraftConfigurationLoading,
    updateDraftConfigurationLoading,
    downloadPriceTypeLoading,
    getOnboardingConfigurationLoading,
    getLiveConfigLoading,
  ]);

  useEffect(() => {
    if (formCount === 5) {
      if (fetchLiveConfigData === null) {
        dispatch({
          type: GET_LIVE_CONFIG,
          payload: {
            urlParams: {
              clientId: state.client?.id,
              projectId: state.project?.id,
              benefitType: state?.benefit?.name,
              benefitGroup: state?.benefitGroup?.id,
              configurationType: 'program_onboarding',
            },
          },
        });
      }
    }
  }, [formCount]);

  useEffect(() => {
    if (getLiveConfig !== null) {
      setFetchLiveConfigData(getLiveConfig?.results?.configuration_data ?? null);
      if (getLiveConfig?.results?.configuration_data) {
        setState(prev => ({
          ...prev,
          ...getLiveConfig.results.configuration_data,
          client: {
            ...getLiveConfig.results.configuration_data?.client,
            carTypes: prev?.client?.carTypes,
          },
          project: prev.project,
          benefit: prev.benefit,
          benefitGroup: prev.benefitGroup,
        }));
      }
      dispatch({
        type: GET_LIVE_CONFIG_EMPTY,
      });
    }
  }, [getLiveConfig]);

  return (
    <div>
      {loading && <Loader />}
      {formCount === 1 && <SelectClient state={state} setState={setState} setFormCount={setFormCount} />}
      {formCount === 2 && <SelectProject state={state} setState={setState} setFormCount={setFormCount} />}
      {formCount === 3 && <SelectBenefit state={state} setState={setState} setFormCount={setFormCount} />}
      {formCount === 4 && <SelectBenefitGroup state={state} setState={setState} setFormCount={setFormCount} />}
      {formCount === 5 && <ClientPricingFlow state={state} setFormCount={setFormCount} />}
      {formCount === 6 && (
        <SelectAirport
          state={state}
          setState={setState}
          setFormCount={setFormCount}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
        />
      )}
      {formCount === 7 && (
        <SelectZone
          setState={setState}
          setFormCount={setFormCount}
          state={state}
          pricingType={'vendorPricing'}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
          fetchLiveConfigData={fetchLiveConfigData}
        />
      )}
      {formCount === 8 && (
        <SelectVendor
          setState={setState}
          setFormCount={setFormCount}
          state={state}
          configuration={configuration}
          isDraftConfiguration={isDraftConfiguration}
        />
      )}
      {formCount === 9 && (
        <AssignZonesToVendors
          setState={setState}
          setFormCount={setFormCount}
          state={state}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
        />
      )}
      {formCount === 10 && <UploadVendorPricing setState={setState} setFormCount={setFormCount} state={state} />}

      {formCount === 11 && (
        <AddVendorPricing
          state={state}
          setState={setState}
          setFormCount={setFormCount}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
        />
      )}

      {formCount === 12 && (
        <SelectZone
          setState={setState}
          setFormCount={setFormCount}
          state={state}
          pricingType={'clientPricing'}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
          fetchLiveConfigData={fetchLiveConfigData}
        />
      )}

      {formCount === 13 && (
        <AssignZonesToClient
          setState={setState}
          setFormCount={setFormCount}
          state={state}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
        />
      )}
      {formCount === 14 && <UploadClientPricing setState={setState} setFormCount={setFormCount} state={state} />}

      {formCount === 15 && (
        <AddClientPricing
          setState={setState}
          setFormCount={setFormCount}
          state={state}
          isDraftConfiguration={isDraftConfiguration}
          configuration={configuration}
        />
      )}
      {formCount === 16 && (
        <ConfigurationChecklist state={state} setFormCount={setFormCount} configuration={configuration} isDraftConfiguration={isDraftConfiguration} />
      )}
    </div>
  );
};

export default ProgramOnboarding;
